<template>
  <div class="py-12">
    <div class="text-4xl text-center">
      Loading...
    </div>
  </div>
</template>
<script>
import {  mapActions, mapMutations } from 'vuex'
export default {
  name: 'LinkedInLogin',
  methods: {
  ...mapMutations ([
      'setSourcingRequestToken'
    ]),
    ...mapActions([
      'openLoginModal'
    ])
  },
  beforeCreate() {
    if (window.opener && window.opener !== window) {
      window.opener.location = window.location.href
      window.close()
    } else {
      if (this.$route.query.result == 1) {
        if (this.$route.query.access_token) {
          this.$router.push({ name: 'Register', query: {access_token: this.$route.query.access_token, email: this.$route.query.email, first_name: this.$route.query.first_name, last_name: this.$route.query.last_name, linked_in_token: this.$route.query.linked_in_token}})
        } else {
          this.$store.dispatch('storeUserAuthInfo', this.$route.query)
          if (localStorage.getItem('previousUrl') !== null) {
            if(localStorage.getItem('existingSourcingToken') !== null) {
              let sourcing_token = localStorage.getItem('existingSourcingToken')
              this.$store.commit('setSourcingRequestToken',sourcing_token)
              localStorage.removeItem('previousUrl')
              localStorage.removeItem('existingSourcingToken')
              this.$router.push({ name: 'Sourcing Request', query: { editing: true }})
            } else {
              let previousurl = localStorage.getItem('previousUrl')
              localStorage.removeItem('previousUrl')
              window.location.href = previousurl
            }
          } else {
            localStorage.removeItem('supplierCriteriaDetails');
            localStorage.removeItem('previousUrl');
            localStorage.removeItem('existingSourcingToken')
            localStorage.removeItem('activeTab')
            this.$router.push({name: 'Home'})
          }
        }
      } else {
        localStorage.removeItem('supplierCriteriaDetails');
        localStorage.removeItem('previousUrl');
        localStorage.removeItem('existingSourcingToken')
        localStorage.removeItem('activeTab')
        this.$notify({
          group: 'buyHive',
          type: 'error',
          text: this.$route.query.message
        })
        this.$router.push({name: 'Home'})
      }
    }
  }
}
</script>